import React from "react";
import { useLocation } from "react-router-dom";

import LanguageSwitch from "./LanguageSwitch";

// Pages people see before signing in. The legal pages are left out: each of them has its
// own French / English version and links between the two.
const PUBLIC_PATHS = [
  /^\/login(\/|$)/i,
  /^\/register(\/|$)/i,
  /^\/admin-login\/?$/i,
  /^\/welcome\/?$/i,
  /^\/get-code\/?$/i,
  /^\/reset-password\/?$/i,
  /^\/authorize\/?$/i,
  /^\/unauthorized\/?$/i,
];

export const isPublicPath = (pathname = "") =>
  PUBLIC_PATHS.some((re) => re.test(pathname));

/** The FR | EN switch in the top right corner of the sign-in, sign-up and reset pages. */
const PublicLanguageSwitch = () => {
  const { pathname } = useLocation();
  if (!isPublicPath(pathname)) return null;
  return (
    <div
      className="fixed right-3 top-3 z-[1300]"
      data-testid="public-language-switch"
    >
      <LanguageSwitch />
    </div>
  );
};

export default PublicLanguageSwitch;
